import { createContext, FC, useReducer } from "react";
import { Outlet } from "react-router-dom";

import { ContextStateProps, StatsContextProps } from "./types";
import { initialState, queryDispatcher } from "./reducer";


export const StatsContext = createContext<StatsContextProps>({
  state: initialState,
  updateState: (state: ContextStateProps) => {},
})


const StatsProvider: FC = (): JSX.Element => {
  const [state, dispatch] = useReducer(queryDispatcher, initialState);

  const updateState = (state: ContextStateProps) => {
    dispatch({
      type: "UPDATE_STATE", payload: state,
    })
  }

  return (
    <StatsContext.Provider value={{ state, updateState }}>
      <Outlet />
    </StatsContext.Provider>
  )
}

export default StatsProvider
